<template>
  <div class="data-table">
    <table>
      <thead />
      <tbody>
        <tr v-for="row,i in data" :key="i">
          <td v-for="val,j in row" :key="j">
            {{ val instanceof Date ? val.getFullYear() : val }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: ['data']
 
}
</script>

<style lang="stylus" scoped>
.data-table
  overflow: auto
  border: solid #fa0
  
  tr:nth-child(even)
    background-color: #f2f2f2

  table
    border-collapse: collapse

  table,
  th,
  td
    border: 1px solid black

  td
    padding: 5px

</style>